// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
import Model, { attr } from '@ember-data/model';

export default class DiagnosisTreatmentPlanModel extends Model {
  @attr() shortType;
  @attr() problem;
  @attr() goal;
  @attr() objective;
  @attr() structure;
  @attr() frequency;
  @attr('moment') notedAt;

  // Keep as a classic @computed so `note-form`'s
  // `@reads('model.diagnosisTreatmentPlan.type')` re-fires when `shortType`
  // changes.
  @computed('shortType')
  get type() {
    return this.shortType || 'empty';
  }
}
